"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.middleEastCountries = exports.ezCountries = exports.ezCCode = void 0;
exports.ezCCode = {
    SG: "SG",
    MY: "MY",
    AU: "AU",
    TH: "TH",
    PK: "PK",
    TWC: "TWC",
    BD: "BD"
};
exports.ezCountries = [exports.ezCCode.SG, exports.ezCCode.MY, exports.ezCCode.TH, exports.ezCCode.TWC, exports.ezCCode.PK];
exports.middleEastCountries = ["SAR", "AED", "OMR", "BHD", "KWD", "QAR"];
